"use client";

import React from "react";
import { PORTAL_THEME } from "../../lib/portal_theme";

// The single, app-wide loading spinner. Use everywhere something is loading so the
// style stays consistent. `size` sets the diameter (px); border scales with it.
// Renders its own keyframes once (id-guarded) so no page-level <style> is needed.
export default function Spinner({ size = 28, color = PORTAL_THEME.accentOrange, track = "#555", style }) {
  const border = Math.max(2, Math.round(size / 12));
  return (
    <>
      <span
        aria-label="Loading"
        role="status"
        style={{
          display: "inline-block",
          width: size,
          height: size,
          border: `${border}px solid ${track}`,
          borderTopColor: color,
          borderRadius: "50%",
          animation: "rg-spin 0.8s linear infinite",
          ...style,
        }}
      />
      <style>{`@keyframes rg-spin { to { transform: rotate(360deg); } }`}</style>
    </>
  );
}
